import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface AnalyticsStatusProps {
  analyticsError: string | null;
  isLoadingAnalytics: boolean;
  onRetry: () => void;
  onConnectAnalytics: () => void;
}

const AnalyticsStatus: React.FC<AnalyticsStatusProps> = ({
  analyticsError,
  isLoadingAnalytics,
  onRetry,
  onConnectAnalytics
}) => {
  if (analyticsError) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="text-center text-red-600">
            <p className="font-medium">Analytics Data Unavailable</p>
            <p className="text-sm mt-1">{analyticsError}</p>
            <div className="mt-4 flex gap-2 justify-center">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={onRetry}
                disabled={isLoadingAnalytics}
              >
                {isLoadingAnalytics ? 'Retrying...' : 'Retry'}
              </Button>
              <Button 
                variant="outline" 
                size="sm" 
                onClick={onConnectAnalytics}
              >
                Connect Analytics
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (isLoadingAnalytics) {
    return (
      <Card>
        <CardContent className="pt-6">
          <div className="text-center text-muted-foreground">
            <p>Loading analytics data...</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return null;
};

export default AnalyticsStatus;
